var map = {
	"./1.png": "c45c",
	"./10.png": "be13",
	"./11.png": "a267",
	"./12.png": "5534",
	"./2.png": "5182",
	"./3.png": "f277",
	"./4.png": "872c",
	"./5.png": "743a",
	"./6.png": "c4f2",
	"./7.png": "30e4",
	"./8.png": "6d16",
	"./9.png": "e6d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe8";